import { useQuery } from '@tanstack/react-query';
import { fetchProviderStats, type ProviderStats } from '../api/statsApi';

/**
 * React Query hook for fetching provider dashboard statistics
 * 
 * Returns stats with automatic caching and refetching
 * Refetches on window focus and every 5 minutes
 * 
 * @returns useQuery result with stats data, loading state, and error
 */
export function useProviderStats() {
  return useQuery<ProviderStats, Error>({
    queryKey: ['provider', 'stats'],
    queryFn: fetchProviderStats,
    staleTime: 1000 * 60 * 5, // Consider data fresh for 5 minutes
    refetchOnWindowFocus: true,
    retry: 2,
  });
}

